import styled from 'styled-components';
import colors from '../../../styles/colors';

const ContainerCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 95%;
    height: 40px;
    /* background-color: ${colors.bgColorBlack2}; */
    /* background: ${colors.gradientCardStatsWrestler}; */
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    border-radius: 10px;
    border: 2px solid white;
    padding: 10px;
    color: white;

    &:hover {
        cursor: pointer;
        background-color: ${colors.bgColorBlack2};
        box-shadow: 0 0 10px rgba(0,0,0,0.8);
    }
`;

const PositionSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 10%;
    height: 100%;

    & h6.position {
        font-size: 16px;
        font-weight: 800;
        color: white;
        margin: 0;
        padding: 0;
    }
`;

const AvatarSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;

    & img.avatar {
        width: 100%;
        min-height: 30px;
        max-height: 30px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`;

const NameSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(85% - 40px);
    height: 100%;

    & h6.name {
        font-size: 14px;
        font-weight: 800;
        color: white;
        margin: 0;
        padding: 0;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
    }
`;

const ValueSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 10%;
    height: 100%;

    & h6.value {
        font-size: 14px;
        font-weight: 500;
        color: white;
        margin: 0;
        padding: 0;
    }
`;

const SingleCardStatWrestlerMobile = (
    {
        key,
        wrestlerId,
        wrestlerAvatar,
        wrestlerName,
        value,
        position,
        onClick
    }
) => {

    
    return (
        <ContainerCard className='container-card' key={key} onClick={onClick}>
            <PositionSpace className='position-space'>
                <h6 className='position'>{position}</h6>
            </PositionSpace>
            <AvatarSpace className='avatar-space'>
                <img src={process.env.REACT_APP_STORAGE_URL + wrestlerAvatar} alt={wrestlerName} className='avatar' />
            </AvatarSpace>
            <NameSpace className='name-space'>
                <h6 className='name'>{wrestlerName}</h6>
            </NameSpace>
            <ValueSpace className='value-space'>
                {/* Se è un numero intero, non fare il toFixed */}
                <h6 className='value'>{Number.isNaN(Number(value)) ? value : (Number(value) % 1 === 0 ? Number(value) : Number(value).toFixed(2))}</h6>
            </ValueSpace>
        </ContainerCard>
    )
}

export default SingleCardStatWrestlerMobile;